module.exports = __webpack_public_path__ + "img/Number=82.40a4837b.png";